import { useMemo } from "react";
import { useConfig } from "../providers/config";
import { cartDataStore } from "../providers/cartDataStore";

export const useGetDeliveryShippingFeePerKg = (): number => {
  const config = useConfig();
  const totalWeight = cartDataStore((state) => state.getProductsTotalWeight());

  const maxWeightFeeStep = config.maxWeightFeeStep ?? 0;
  const extraWeightFee = config.extraWeightFee ?? 0;
  const isWeightFeeEnabled = config.isWeightFeeEnabled;
  const maxWeightForFeeKG = config.maxWeightForFeeKG ?? 0;

  return useMemo(() => {
    if (!isWeightFeeEnabled || maxWeightFeeStep <= 0 || totalWeight <= maxWeightForFeeKG) {
      return 0;
    }

    const extraWeight = totalWeight - maxWeightForFeeKG;

    return Math.ceil(extraWeight / maxWeightFeeStep) * extraWeightFee;
  }, [isWeightFeeEnabled, maxWeightFeeStep, totalWeight, maxWeightForFeeKG, extraWeightFee]);
};